import { List, Tag } from "antd-mobile";
import React, { useContext, useState } from "react";
import { Button, Card, Typography, Grid, Box } from "@mui/material";
import {
  AddBusiness, // New icon for "Add Establishment"
  CheckCircleOutline, // New icon for "Pending Approval"
  Visibility, // New icon for "View Establishment"
  Person, // New icon for "My Profile"
} from "@mui/icons-material";
import PsContext from "../../context";
//import ViewTasks from "./viewTasks";
import Header from "../header";
//import AddTask from "./addTask";
import { MuiModalWindow } from "../../utils";
import ViewEstablishment from "./viewEstablishment";
//import ViewTaskCategories from "./viewTaskCategories";

const Establishment = () => {
  const context = useContext(PsContext);
  const [showList, setShowList] = useState(false);
  const [showCategory, setShowCategory] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);

  // Conditional Rendering: if no access, show the task list directly
  if (
    !context.allowedAccess("mob_allow_estblishment_approval", "action_update")
  ) {
    return (
      <>
        <Header backAction={true} title="Establishment" />
        <div className="container">
          <Card className="mb-2">
            <div className="py-md-3"></div>
            <div className="container-sm" data-aos="zoom-in">
              <ViewEstablishment />
            </div>
          </Card>
        </div>
      </>
    );
  }

  const dashboardItems = [
    {
      title: "Pending Approval",
      icon: <CheckCircleOutline fontSize="large" style={{ color: "white" }} />, // Updated icon
      bgColor: "#4caf50",
      action: () => setShowList(true),
    },
    {
      title: "View Establishment",
      icon: <Visibility fontSize="large" style={{ color: "white" }} />, // Updated icon
      bgColor: "#2196f3",
      action: () => setShowList(true),
    },
    {
      title: "My Profile",
      icon: <Person fontSize="large" style={{ color: "white" }} />, // Updated icon
      bgColor: "#f44336",
      action: () => alert("Navigating to My Profile"),
    },
    {
      title: "Add Establishment",
      icon: <AddBusiness fontSize="large" style={{ color: "white" }} />, // Updated icon
      bgColor: "#ff9800",
      action: () => setShowAddModal(true),
    },
  ];

  return (
    <>
      <Header backAction={true} title="Establishment" />
      <div className="container-sm">
        <Box p={2}>
          {/*  {showList ? (
            <ViewTasks goBackToDashboard={() => setShowList(false)} />
          ) : showCategory ? (
            <ViewTaskCategories
              goBackToDashboard={() => setShowCategory(false)}
            />
          ) : ( */}
          <Grid container spacing={3}>
            {dashboardItems.map((item, index) => (
              <Grid item xs={6} sm={6} md={3} key={index}>
                <Card
                  elevation={3}
                  onClick={item.action}
                  className="border-0"
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    cursor: "pointer",
                    backgroundColor: item.bgColor,
                    borderRadius: "15px",
                    height: "150px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                  data-aos="zoom-in"
                >
                  <Box>
                    {item.icon}
                    <Typography variant="subtitle1" style={{ color: "white" }}>
                      {item.title}
                    </Typography>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
          {/*  )} */}
        </Box>
      </div>
      {/*  <MuiModalWindow
        open={showAddModal}
        onClose={(e) => setShowAddModal(false)}
        title="Add Task"
      >
        <AddTask
          onSuccess={(e) => {
            setShowAddModal(false);
          }}
        />
      </MuiModalWindow> */}
    </>
  );
};

export default Establishment;
